<td class="align-middle">
    <div class="div-state" [ngClass]="'state-' + colorCode">&nbsp;</div>
</td>

<!-- Payment type -->
<td>
    <input id="{{idPrefix}}type"
           type="text" class="full-width"
           [(ngModel)]="payment.type"
           disabled />
</td>

<!-- Receiver -->
<td>
    <input id="{{idPrefix}}receiver"
           type="text" class="full-width"
           [(ngModel)]="payment.receiver"
           disabled />
</td>

<td>
    <input id="{{idPrefix}}amount"
           type="text" class="full-width" currency
           [(ngModel)]="payment.amount"
           disabled />
</td>

<td>
    <input id="{{idPrefix}}received"
           type="text" class="full-width" currency
           [(ngModel)]="payment.received"
           disabled />
</td>

<td align="center" class="align-middle">
    <strong><span [ngClass]="'state-' + colorCode">{{ payment.received_percentage | number: '1.2-2' }}</span></strong>
</td>

<td>
    <input id="{{idPrefix}}outstanding"
           type="text" class="full-width" currency
           [(ngModel)]="payment.outstanding"
           disabled />
</td>

<td>
    <input id="{{idPrefix}}paid"
           type="text" class="full-width" currency
           [(ngModel)]="payment.paid"
           disabled />
</td>

<td>
    <input id="{{idPrefix}}open"
           type="text" class="full-width" only-digits
           [(ngModel)]="payment.open"
           disabled />
</td>

<td>
    <div class="payment-datepicker text-nowrap">
        <input id="{{idPrefix}}booking_date"
               class="payment-datepicker"
               [matDatepicker]="pickerBookingDate"
               [(ngModel)]="payment.booking_date"
               disabled />

        <button id="{{idPrefix}}btn.pickerBookingDate"
               mat-icon-button class="payment-icon-button"
               type="button"
               disabled >
           <mat-icon class="dr-material-icon">date_range</mat-icon>
       </button>
               <!-- <mat-datepicker-toggle matSuffix [for]="pickerBookingDate"></mat-datepicker-toggle>-->
        <mat-datepicker #pickerBookingDate></mat-datepicker>
    </div>
</td>

<td>
    <div class="payment-datepicker text-nowrap">
        <input id="{{idPrefix}}payment_target"
               [matDatepicker]="pickerPaymentTarget"
               [(ngModel)]="payment.payment_target"
               disabled />
        
        <button id="{{idPrefix}}btn.pickerPaymentTarget"
               mat-icon-button class="payment-icon-button"
               type="button"
               disabled >
           <mat-icon class="dr-material-icon">date_range</mat-icon>
       </button>
        <!-- <mat-datepicker-toggle matSuffix [for]="pickerPaymentTarget"></mat-datepicker-toggle> -->
        <mat-datepicker #pickerPaymentTarget></mat-datepicker>
    </div>
</td>

<!-- Actions -->
<td>
    <button id="{{idPrefix}}btn.remove"
            mat-icon-button class="payment-icon-button"
            (click)="removePayment()">
        <mat-icon class="dr-material-icon" matTooltip="{{ 'common.label.delete' | translate }}">clear</mat-icon>
    </button>

    <button id="{{idPrefix}}btn.edit"
            mat-icon-button class="payment-icon-button"
            (click)="editPayment()">
        <mat-icon class="dr-material-icon" matTooltip="{{ 'common.btn.edit' | translate }}">edit</mat-icon>
    </button>
</td>
